import { Link } from "react-router-dom";
import { Header } from "@/components/Header";
import { ScrollText } from "lucide-react";

export function LegalLayout({ title, updated, children, testid }) {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="max-w-3xl mx-auto px-6 md:px-8 py-16" data-testid={testid}>
        <div className="flex items-center gap-2 mb-2">
          <ScrollText className="h-5 w-5 text-primary" />
          <p className="text-xs uppercase tracking-[0.2em] font-semibold text-primary">Legal</p>
        </div>
        <h1 className="font-display text-4xl sm:text-5xl font-extrabold tracking-tighter mb-2">{title}</h1>
        <p className="text-sm text-muted-foreground mb-10">Last updated: {updated}</p>
        <div className="space-y-8 leading-relaxed text-[15px] text-foreground/90">{children}</div>

        <div className="mt-14 border-t border-border pt-6 flex flex-wrap gap-x-6 gap-y-2 text-sm">
          <Link to="/terms" className="text-primary font-semibold" data-testid="legal-link-terms">Terms of Service</Link>
          <Link to="/privacy" className="text-primary font-semibold" data-testid="legal-link-privacy">Privacy Policy</Link>
          <Link to="/acceptable-use" className="text-primary font-semibold" data-testid="legal-link-acceptable-use">Acceptable Use Policy</Link>
          <Link to="/" className="text-muted-foreground hover:text-foreground" data-testid="legal-link-home">Back to home</Link>
        </div>
      </main>
    </div>
  );
}

export function LegalSection({ heading, children, testid }) {
  return (
    <section data-testid={testid}>
      <h2 className="font-display text-xl font-bold mb-2">{heading}</h2>
      <div className="space-y-3 text-muted-foreground">{children}</div>
    </section>
  );
}
